import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, ScanFace, X } from "lucide-react";
import { LangToggle, ThemeToggle } from "../../components/controls/Toggles";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

export const SignupHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="neu flex h-12 w-12 items-center justify-center rounded-2xl p-0">
          <ScanFace className="h-6 w-6 text-primary" />
        </div>
        <div>
          <p className="text-xl font-black">{t("signup.title")}</p>
          <p className="text-xs text-muted-foreground">{t("signup.subtitle")}</p>
        </div>
      </div>
      <div className="flex gap-2">
        <LangToggle />
        <ThemeToggle />
        <NeuButton
          className="px-3 py-3"
          data-testid="signup-close"
          aria-label={t("reset.backToLogin")}
          onClick={() => navigate("/login")}
        >
          <X className="h-4 w-4" />
        </NeuButton>
      </div>
    </div>
  );
};

export const SignupDone = () => {
  const { t } = useTranslation();
  return (
    <NeuCard className="animate-pop text-center" data-testid="signup-done">
      <CheckCircle2 className="mx-auto h-10 w-10 text-success" />
      <p className="mt-4 text-lg font-bold">{t("signup.done")}</p>
      <p className="mt-2 text-sm text-muted-foreground">{t("signup.doneBody")}</p>
      <Link to="/login" className="mt-4 inline-block text-sm font-semibold text-primary">
        {t("auth.signIn")}
      </Link>
    </NeuCard>
  );
};
